import * as React from "react";
import { forwardRef } from "react";
const SvgIconSearch = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#777E91", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.906 16.32a8 8 0 1 1 1.414-1.414l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387ZM16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z", fill: "currentColor", opacity: 0.6 }));
const ForwardRef = forwardRef(SvgIconSearch);
export default ForwardRef;
